<template>
  <div>
    <b-autocomplete
      :key="searchRenderKey"
      v-model="relatedProtocol.protocolId"
      :error-messages="getErrorMessages(v$.protocolId)"
      :item-title="
        item => `${item.name} ${item.number ? `(${item.number})` : null}`
      "
      :items="searchProtocolList"
      class="mb-4"
      item-value="id"
      no-filter
      placeholder="Оберіть протокол"
      @blur="v$.protocolId.$touch()"
      @update:model-value="handleModelUpdate"
      @update:search="handleSearch"></b-autocomplete>
  </div>
</template>

<script lang="ts">
import { PropType, reactive, ref, Ref } from 'vue'
import { axios, required, useVuelidate } from '@/plugins'
import { urlProtocolRelatedAdd } from '@/utils/urls.js'
import { debounce } from 'lodash'
import { getErrorMessages } from '@/utils/helpers.js'
import { Dialog } from '@/dialog'
import { sendRequest } from 'best-modules/vue-utils'

export default {
  name: 'RelatedProtocol',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  async setup(props) {
    const searchProtocolList = ref<any[]>([])
    const searchRenderKey: Ref<number> = ref(1)

    const relatedProtocol = reactive({
      protocolId: null as any,
    })

    const selectingItem: Ref<boolean> = ref(false)

    const handleModelUpdate = (protocolId: number): void => {
      selectingItem.value = true
      relatedProtocol.protocolId = protocolId
    }

    const handleSearch = debounce((search: string) => {
      if (selectingItem.value) {
        selectingItem.value = false
        return
      }

      if (search) {
        return sendRequest({
          name: 'globalSearch',
          method: 'get',
          url: {
            url: '/json/generalSearch',
            query: {
              search,
              types: ['order'],
            },
          },
        }).then(res => {
          searchProtocolList.value = res.order
        })
      }
    }, 400)

    const v$ = useVuelidate({ protocolId: { required } }, relatedProtocol)

    const submit = () => {
      return axios
        .post(urlProtocolRelatedAdd(), {
          parentProtocolId: props.dialog.dialogData.protocolId,
          childrenProtocolId: relatedProtocol.protocolId,
        })
        .then(res => {
          return res.data
        })
    }

    return {
      relatedProtocol,
      v$,
      submit,
      searchProtocolList,
      handleSearch,
      handleModelUpdate,
      searchRenderKey,
    }
  },
}
</script>
